import { resolveSiteTimeZone } from '../siteTime/siteTime';
import { SHOWCASE2_PATH } from './showcasePresentation';

/** Customer views for org acme, site yyz. */
export const SHOWCASE_CUSTOMER_SITE_ID = 'yyz';
export const SHOWCASE_CUSTOMER_TIME_ZONE = 'America/Vancouver';

/** Edgentik Box #1 on /showcase (device demo5). */
export const SHOWCASE_LIVE_BOOTH_CONDITION_ID = '851914d7-cb07-59ff-80fd-f123a889056e';
/** Edgentik Box #2 on /showcase2 (device Demo). */
export const SHOWCASE_DEMO_UNIT_CONDITION_ID = 'b64914fb-b432-5021-acf2-c0a9a4fde528';
export const SHOWCASE_CUSTOMER_DEMO5_LABEL = 'Edgentik Box #1';
export const SHOWCASE_CUSTOMER_DEMO_LABEL = 'Edgentik Box #2';

export { SHOWCASE2_PATH };

export type ShowcaseAskBinding = {
  siteId: string;
  conditionId: string;
};

/** Route split: /showcase is Edgentik Box #1, /showcase2 is Edgentik Box #2. */
export function showcaseAskBinding(pathname: string): ShowcaseAskBinding {
  const demoUnit = pathname === SHOWCASE2_PATH || pathname.startsWith(`${SHOWCASE2_PATH}/`);
  return {
    siteId: SHOWCASE_CUSTOMER_SITE_ID,
    conditionId: demoUnit ? SHOWCASE_DEMO_UNIT_CONDITION_ID : SHOWCASE_LIVE_BOOTH_CONDITION_ID,
  };
}

/**
 * Customer Showcase clocks use the site IANA zone through the site-time helpers.
 * A missing zone, UTC, or the Ask demo page's America/Toronto assumption falls
 * back to America/Vancouver. Offsets are not hardcoded.
 */
export function showcaseCustomerTimeZone(...candidates: Array<string | null | undefined>): string {
  for (const candidate of candidates) {
    const zone = resolveSiteTimeZone(candidate);
    if (!zone || zone === 'UTC' || zone === 'America/Toronto') continue;
    return zone;
  }
  return SHOWCASE_CUSTOMER_TIME_ZONE;
}
